jQuery( document ).ready(function() {

    // CircleType
    jQuery(".circle-text").each(function() {
        var circleType = new CircleType(jQuery(this)[0]),
        theradius = $(this).innerWidth() / 2;


        circleType.radius(theradius);

        if( $(this).hasClass('reverse') ){
          circleType.dir(-1);
        }

        // Border text offset
        if( jQuery(this).data('border-text-offset') ) {
            jQuery(this).css({ 'transform' : 'rotate('+jQuery(this).data('border-text-offset')+'deg)' });
        }
    });

});